import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../api";

/*
 * TWO THINGS THE MENU NEEDS THAT THE ADDRESS CANNOT GIVE IT.
 *
 * 1. The Follow-ups badge: what is left to work today. Counted by the server
 *    from the same getFollowUps the page reads, so the badge and the page are
 *    one number. Polled every two minutes: the batch only shrinks when he works
 *    a row, and that happens on the page, which hands the menu its own count
 *    every time it reloads (setFollowUps).
 *
 * 2. A page's own answer to "which menu item am I?". An automation's record is
 *    at /automations/:id, and only the record knows whether that is an inbound
 *    or a meetings automation. The page says so with useNavHint once it has
 *    loaded, and clears it when it unmounts.
 */
const NavContext = createContext({
  followUps: 0,
  refreshFollowUps: () => {},
  setFollowUps: () => {},
  hint: null,
  setHint: () => {},
});

export function NavProvider({ children }) {
  const [followUps, setFollowUps] = useState(0);
  const [hint, setHint] = useState(null);

  const refreshFollowUps = useCallback(async () => {
    try {
      const { to_work: n } = await api("/follow-ups/count");
      setFollowUps(n || 0);
    } catch {
      /* leave the last known count on a transient error */
    }
  }, []);

  useEffect(() => {
    refreshFollowUps();
    const t = setInterval(refreshFollowUps, 120000);
    return () => clearInterval(t);
  }, [refreshFollowUps]);

  return (
    <NavContext.Provider value={{ followUps, refreshFollowUps, setFollowUps, hint, setHint }}>{children}</NavContext.Provider>
  );
}

export function useNav() {
  return useContext(NavContext);
}

/** Tell the menu where this page lives, as "area/item". Null says nothing. */
export function useNavHint(value) {
  const { setHint } = useContext(NavContext);
  useEffect(() => {
    setHint(value || null);
    return () => setHint(null);
  }, [value, setHint]);
}
